// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://hjodtxoylcvcwjgvuctk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhqb2R0eG95bGN2Y3dqZ3Z1Y3RrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc5NTc0NjYsImV4cCI6MjA2MzUzMzQ2Nn0.fU5R1Uv4REaVo_ps4K9gcxXEcbD2Ir4CLg63HAE1cF4";
/** Anon key (same as publishable). Used for edge function calls that need apikey + user JWT. */
export const SUPABASE_ANON_KEY = SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});